import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { INDDGridStateColumn } from '@ndk/ng-grid';
import { NDDGridAbstractSettingsService } from '@ndk/ng-grid/component/shared/ndd-ng-grid-settings.service';
import { Observable } from 'rxjs';

import { ICoreConfigInternal } from '@core/core.config.model';

@Injectable()
export class CustomGridSettingsService extends NDDGridAbstractSettingsService {
    constructor(@Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal, http: HttpClient) {
        super(new HttpParams(), http);
        this.api = `${ config.apiEndpoint }api/grid-columns`;
    }

    /** @override */
    public updateSettings(gridId: string, columns: INDDGridStateColumn[]): Observable<boolean> {
        return this.postSettings(gridId, columns);
    }

    /** @override */
    public updateRestoreDefaultSettings(gridId: string): Observable<boolean> {
        return this.postRestoreDefaultSettings(gridId);
    }

    /** @override */
    public postRestoreDefaultSettings(gridId: string): Observable<boolean> {
        return this.http.post<boolean>(`${ this.api }/restore-default`, { gridId });
    }
}
